export const calculateTotalSessions = (product) => {
  const rateLinks = product?.rateLinks;

  if (!rateLinks?.length) {
    return 0;
  }

  const hasInvalidQuantity = rateLinks.some(
    (link) => link.quantity == null || !isFinite(Number(link.quantity)),
  );

  if (hasInvalidQuantity) {
    return null;
  }

  return rateLinks.reduce((total, link) => total + Number(link.quantity), 0);
};
